import { State } from './connection.store';

export abstract class ConnectionLoader {
  abstract load(): Promise<State>;
}

export abstract class ConnectionSaver {
  abstract save(connectionState: State): Promise<State>;
}
